import { render, staticRenderFns } from "./mailbox-settings-office-hours-tooltip.vue?vue&type=template&id=00e59b3e&"
import script from "./mailbox-settings-office-hours-tooltip.vue?vue&type=script&lang=ts&"
export * from "./mailbox-settings-office-hours-tooltip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports